<script lang="ts">
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import { getCloudinaryUrl } from "@shared/services/cloudinary_image_url_service";
  import { cloudinaryParams } from "@shared/services/discovery_image_dimensions";

  import type { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

  export let image_alt_text: string;
  export let mobileMode: boolean;
  export let image_upload_url: string;
  export let href: string;
  export let target: string;
  export let hoveringOnImage: boolean;
  export let displayIsVertical: boolean;
  export let dataTestIdSuffix: string = "";
  export let handleClick: (entities: BaseEntityClass[]) => void;

  const testIdSuffix = dataTestIdSuffix ? `-${dataTestIdSuffix}` : "";
  const dataTestId = `content-block-image${testIdSuffix}`;

  const enter = () => {
    hoveringOnImage = true;
  };
  const leave = () => {
    hoveringOnImage = false;
  };

  const imageSrc =
    //@ts-ignore
    window.C.IMAGE_PATHS[image_upload_url] ||
    getCloudinaryUrl(image_upload_url, cloudinaryParams.contentBlock);

</script>

<style>
  .content-block-image-container {
    min-width: 216px;
    max-width: 360px;
  }
  .content-block-image-container-vertical {
    width: 216px;
  }
  .content-block-image {
    border-radius: 15px;
  }

</style>

<TrackingContext let:trackingContext>
  <div
    class="fizz-align-self-center content-block-image-container"
    class:fizz-flex-no-shrink={!mobileMode}
    class:content-block-image-container-vertical={displayIsVertical}
    data-testid={dataTestId}
  >
    <a
      {href}
      {target}
      on:click={() => handleClick(trackingContext.entities)}
      on:mouseover={enter}
      on:focus={enter}
      on:mouseleave={leave}
    >
      <img
        src={imageSrc}
        alt={image_alt_text}
        class="content-block-image"
        data-testid="content-block-image"
      />
    </a>
  </div>
</TrackingContext>
